import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import footerBusinessImage from "../../../../assets/preview/linkedIn-business-preview-footer.png";
import footerImage from "../../../../assets/preview/linkedin-buttons-footer.png";
import { useLinkedInCore } from "../../../../cores/linkedIn";
import { useLinkedInBusinessCore } from "../../../../cores/linkedInBusiness";
import { SocialPost } from "../../../../cores/socialPost/interfaces/api/get-social-posts";
import { DropdownOptions } from "./DropdownOptions";
import { MediaPreview } from "./MediaPreview";

interface Props {
  business?: boolean;
  post: SocialPost;
  onDelete: () => void;
  onEdit: () => void;
}

export const LinkedInPostPreview = (props: Props) => {
  const { business, post, onEdit, onDelete } = props;
  const { settings: businessSettings } = useLinkedInBusinessCore();
  const { settings: normalSettings } = useLinkedInCore();
  const settings = business ? businessSettings : normalSettings;
  const { name: defaultName, avatarUrl: defaultAvatar } = settings || {};
  const { publisherName: name, publisherAvatarUrl: avatarUrl } =
    post.post || {};

  const formattedText = useMemo(() => {
    const orderMentions = 
      (post.mention || []).slice().sort((a, b) => (a.offset > b.offset) ? -1 : 1);

    let txt = post.post.text;
    orderMentions.forEach((mention) => {
      const name = `<span style="color:#38b6ff;">${mention.mentions[0].username}</span>`
      const offset = mention.offset + mention.mentions[0].username.length + 1
      txt = txt.slice(0, mention.offset) + name + txt.slice(offset);
    });
    
    return txt;
  }, [post.mention, post.post.text]);
  
  return (
    <>
      <Row className="linkedInPreview-header">
        <Col xs="10" className="d-flex align-items-center p-0">
          <div>
            <img
              className="linkedInPreview-header-avatar"
              src={avatarUrl || defaultAvatar}
              alt="avatar"
            />
          </div>
          <div>
            <div className="font-weight-bold">{name || defaultName}</div>
            <div className="text-muted">
              {post.post.postAt ? (
                moment(post.post.postAt).format("DD MMM YYYY hh:mm a")
              ) : (
                <span className="text-warning">
                  {moment(post.post.scheduleDate).format("DD MMM YYYY hh:mm a")}{" "}
                  <FontAwesomeIcon icon={["far", "clock"]} />
                </span>
              )}
            </div>
          </div>
        </Col>
        <Col xs="2" className="align-content-center d-flex justify-content-end">
          {post.post.status === 0 && (
            <DropdownOptions
              children={
                <FontAwesomeIcon
                  className="pointer"
                  icon={["fas", "ellipsis-h"]}
                />
              }
              onEdit={onEdit}
              onDelete={onDelete}
            />
          )}
        </Col>
      </Row>
      <Row className="linkedInPreview-description">
        <Col xs="12" className="line-break-anywhere p-0 pre-wrap">
          <div dangerouslySetInnerHTML={{
            __html: formattedText
          }}></div>
        </Col>
      </Row>
      <Row>
        <Col xs="12" className="p-0">
          {post.media.length > 0 && (
            <MediaPreview
              className="linkedInPreview-image"
              type={post.post.type}
              media={post.media}
            />
          )}
        </Col>
      </Row>
      <Row>
        <img
          className="linkedInPreview-footer"
          src={business ? footerBusinessImage : footerImage}
          alt="footer"
        />
      </Row>
    </>
  );
};
